import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "qin-form qin-form--auth" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "qin-form__logo-wrapper" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "qin-form__logo",
    src: "/static/app/quod-logo.png",
    alt: "qin-logo-image"
  })
], -1)
const _hoisted_3 = { class: "qin-form__title" }
const _hoisted_4 = { class: "ds-caption ds-caption--size_3xl ds-caption--bold" }
const _hoisted_5 = { class: "qin-form__subtitle" }
const _hoisted_6 = { class: "ds-caption ds-caption--size_xs ds-caption--color_semigrey" }
const _hoisted_7 = { class: "qin-form__wrapper" }
const _hoisted_8 = { class: "error-label" }
const _hoisted_9 = { class: "g-row g-row--appearance_spaced g-row--space_sm g-row--space_xl-xl g-row--justify_center g-row--align_center" }
const _hoisted_10 = { class: "g-cell g-cols g-cols--12" }
const _hoisted_11 = { class: "g-cell g-cols g-cols--12 relative" }
const _hoisted_12 = { class: "g-cell g-cols g-cols--narrow" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "g-cell g-cols g-cols--12" }, [
  /*#__PURE__*/_createElementVNode("button", {
    class: "qin-button qin-button--main qin-button--accent qin-button--full_width qin-button--offset_top-md",
    type: 'submit'
  }, [
    /*#__PURE__*/_createElementVNode("span", { class: "qin-button__text" }, /*#__PURE__*/_toDisplayString('Log In'))
  ])
], -1)
const _hoisted_14 = { class: "recaptcha-field g-recaptcha" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loader = _resolveComponent("loader")!
  const _component_VeeError = _resolveComponent("VeeError")!
  const _component_d_control_input = _resolveComponent("d-control-input")!
  const _component_VeeForm = _resolveComponent("VeeForm")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($setup.load)
      ? (_openBlock(), _createBlock(_component_loader, { key: 0 }))
      : _createCommentVNode("", true),
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("p", _hoisted_4, _toDisplayString($setup.$t('Log In')), 1)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("p", _hoisted_6, _toDisplayString($setup.$t('Enter your email address and password to access your personal cabinet')), 1)
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createVNode(_component_VeeForm, {
        onSubmit: $setup.request,
        ref: "form"
      }, {
        default: _withCtx(({ errors }) => [
          _createVNode(_component_VeeError, { name: "nonFieldErrors" }, {
            default: _withCtx(({ message }) => [
              _createElementVNode("div", _hoisted_8, _toDisplayString(message), 1)
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createVNode(_component_d_control_input, {
                rules: "required|email|max:255",
                name: "email",
                type: "text",
                "input-label": $setup.$t("E-mail"),
                modelValue: $setup.email,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.email) = $event))
              }, null, 8, ["input-label", "modelValue"])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createVNode(_component_d_control_input, {
                rules: "required|max:255",
                name: "password",
                type: "password",
                "input-label": $setup.$t("Password"),
                modelValue: $setup.password,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.password) = $event))
              }, null, 8, ["input-label", "modelValue"])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("p", {
                class: "ds-caption ds-caption--color_accent ds-caption--size_sm hovered_underline",
                onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => ($setup.toResetForm()), ["prevent"]))
              }, _toDisplayString($setup.$t('Forgot your password?')), 1)
            ]),
            _hoisted_13
          ])
        ]),
        _: 1
      }, 512),
      _createElementVNode("div", _hoisted_14, [
        _createVNode($setup["vueRecaptcha"], {
          size: "invisible",
          sitekey: $setup.key,
          onVerify: _cache[3] || (_cache[3] = ($event: any) => ($setup.recaptchaVerified($event, $setup.request))),
          ref: "recaptcha"
        }, null, 8, ["sitekey"])
      ])
    ])
  ]))
}